import { useCallback, useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';

export default function useShowPreOrder(): () => void {
  const { setPreOrderModalOpen } = useContext(ModalContext);

  return useCallback(() => {
    setPreOrderModalOpen(true);
  }, [setPreOrderModalOpen]);
}
